import { Badge, Button, Text, Title } from './element-variations';

export const Elements = ({
  googleAnalyticsExtraParameters,
  data,
  isDrag,
  isMobile
}) => {
  const {
    contentTitleText,
    contentTextText,
    contentTitleEnabled,
    contentTextEnabled,
    contentButtonEnabled,
    contentButtonText,
    contentBadgeEnabled,
    contentBadgeText
  } = data;

  const items = [
    contentBadgeEnabled && contentBadgeText && (
      <Badge key={1} data={data} isMobile={isMobile} />
    ),
    contentTitleEnabled && contentTitleText && (
      <Title key={2} data={data} isMobile={isMobile} />
    ),
    contentTextEnabled && contentTextText && (
      <Text key={3} data={data} isMobile={isMobile} />
    ),
    contentButtonEnabled && contentButtonText && (
      <Button
        googleAnalyticsExtraParameters={googleAnalyticsExtraParameters}
        key={4}
        data={data}
        isDrag={isDrag}
        isMobile={isMobile}
      />
    )
  ];

  return items.filter((item) => item !== false).length ? items : [];
};
